import Store from '../store/store'

export default class BeatPrice {
    constructor(data) {
        this.price = 0;

        for (var i in data) {
            this[i] = data[i];
        }

        this.price = parseFloat(this.price);
        this.license = Store.state.user.licenseById(this.license);
    }

    isSaleable() {
        return this.license.enabled && this.price > 0
    }

    hasDiscount() {
        return this.license.discountsAvailable() && this.discount;
    }
}